import React from 'react'
import { ProductInfoItem } from 'components/ProductInfo'
import { Flex, Text } from 'theme-ui'
import OrgStaticPage from 'components/Organization/HomePage/OrgStaticPage'
import { MainContentContainer, StaticPageBody, TitleSection } from 'components/NewStaticPage'
import NewProductInfo from 'components/ProductInfo/ProductInfo'

export default function Privacy({ items }: { items: ProductInfoItem[] }): React.ReactElement {
  return (
    <OrgStaticPage>
      <StaticPageBody sxBody={{ px: ['1.2rem', '1.2rem', 0] }}>
        <TitleSection>
          <Flex
            sx={{
              flexDirection: 'column',
              textAlign: 'center',
              gap: '1.6rem',
            }}
          >
            <Text
              variant="smallPageHeading"
              as="h1"
              sx={{
                fontSize: '4rem',
                color: 'aliceBlue',
              }}
            >
              Privacy Policy
            </Text>
            <Text sx={{ fontSize: '1.6rem', color: 'lightSteelBlue', fontWeight: '400' }}>
              Last updated on 2025-03-08
            </Text>
          </Flex>
        </TitleSection>
        <MainContentContainer sxContainer={{ px: ['1.6rem', '4.8rem'], py: '4.8rem' }}>
          <NewProductInfo items={items} />
        </MainContentContainer>
      </StaticPageBody>
    </OrgStaticPage>
  )
}
